<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <b-tabs content-class="mt-3">
                        <b-tab title="Mapping thông tin tài sản theo nhóm" active>
                            <b-form @submit.prevent="search">
                                <b-row>
                                    <b-col offset-md="2">
                                        <b-form-group label="Nhóm tài sản:"
                                                      label-cols-md="2"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <treeselect v-model="searchForm.assetTypeGroupId"
                                                        class="no-padding col-md-6"
                                                        :defaultExpandLevel="1"
                                                        :always-open="false"
                                                        :append-to-body="true"
                                                        :max-height="390"
                                                        placeholder="Nhập tên nhóm tài sản"
                                                        :options="assetTypeGroups" />
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col offset-md="2">
                                        <b-form-group label="Loại biến động:"
                                                      label-cols-md="2"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <div class="col-md-6 no-padding">
                                                <select2 v-model="searchForm.assetMutationTypeId" :options="assetMutationTypes" style="width:100%"></select2>
                                            </div>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col offset-md="2">
                                        <b-form-group label="" :label-cols="4" label-cols-md="2">
                                            <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                            <b-button type="button" variant="secondary" :to="{ path: `./display?assetTypeGroupId=${searchForm.assetTypeGroupId}&assetMutationTypeId=${searchForm.assetMutationTypeId}` }" v-show="searchForm.assetTypeGroupId && searchForm.assetMutationTypeId">Xem giao diện</b-button>
                                            <b-button type="button" variant="secondary" @click="exportExcel" v-show="searchForm.assetTypeGroupId && searchForm.assetMutationTypeId">Xuất Excel Mapping</b-button>
                                            <b-button type="button" variant="secondary" @click="exportServiceExcel" v-show="searchForm.assetTypeGroupId && searchForm.assetMutationTypeId">Xuất Service Mapping</b-button>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-form>
                            <b-form @submit.prevent="importExcel">
                                <b-row>
                                    <b-col offset-md="2">
                                        <b-form-group label="File import:"
                                                      :label-cols="4"
                                                      label-cols-md="2"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <b-form-file v-model="$v.importFile.$model" class="col-md-6"
                                                         :state="$v.importFile.$dirty? !$v.importFile.$error : null"
                                                         accept=".xlsx, .xls"
                                                         browse-text="Chọn"
                                                         placeholder="Chọn tệp tải lên..."></b-form-file>
                                            <b-form-invalid-feedback>
                                                Vui lòng chọn file import
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col offset-md="2">
                                        <b-form-group label="" :label-cols="4" label-cols-md="2">
                                            <b-button type="submit" variant="primary">Import</b-button>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-form>
                            <br />
                            <b-grid :searchForm="searchForm"
                                    :gridOptions="gridOptions"
                                    :items="mappingFields"
                                    :filter="searchForm.filter"
                                    :showActions="false"
                                    gridName="Danh sách mapping"
                                    ref="mappingTable">
                                <template v-slot:actions="row">
                                    <b-form-input v-model="searchForm.filter" placeholder="Nhập từ khóa"></b-form-input>
                                    <br />
                                </template>
                                <template v-slot:cell(_actions)="row">
                                    <b-button-group>
                                        <b-button size="sm" @click.stop="removeField(row.item, row.index, $event.target)" title="xóa">
                                            <i class="fa fa-trash-o" aria-hidden="true"></i>
                                        </b-button>
                                        <b-button size="sm" @click.stop="moveUp(row.item, row.index, $event.target)" v-if="row.index > 0">
                                            <i class="fa fa-arrow-circle-up" aria-hidden="true"></i>
                                        </b-button>
                                        <b-button size="sm" @click.stop="moveDown(row.item, row.index, $event.target)" v-if="row.index < mappingFields.length + 1">
                                            <i class="fa fa-arrow-circle-down" aria-hidden="true"></i>
                                        </b-button>
                                    </b-button-group>
                                </template>

                                <!--<template v-slot:cell(displayName)="row">
                                    <b-form-input v-model="row.item.displayName" class="no-padding"></b-form-input>
                                </template>
                                <template v-slot:cell(displayGroup)="row">
                                    <b-form-input v-model="row.item.displayGroup" class="no-padding"></b-form-input>
                                </template>-->
                                <template v-slot:cell(isRequired)="row">
                                    <b-form-checkbox v-model="row.item.isRequired" disabled></b-form-checkbox>
                                </template>
                                <template v-slot:cell(isDisplayed)="row">
                                    <b-form-checkbox v-model="row.item.isDisplayed" disabled></b-form-checkbox>
                                </template>
                                <template v-slot:cell(fieldIsNullable)="row">
                                    <b-form-checkbox v-model="row.item.fieldIsNullable" disabled></b-form-checkbox>
                                </template>
                                <template v-slot:cell(displayNewLine)="row">
                                    <b-form-checkbox v-model="row.item.displayNewLine" disabled></b-form-checkbox>
                                </template>
                                <!--<template v-slot:cell(displayGridColumn)="row">
                                    <b-form-select v-model="row.item.displayGridColumn" :options="bootstrapGridOptions" class="no-padding"></b-form-select>
                                </template>
                                <template v-slot:cell(displayLabelColumn)="row">
                                    <b-form-select v-model="row.item.displayLabelColumn" :options="bootstrapGridOptions" class="no-padding"></b-form-select>
                                </template>-->
                                <template v-slot:cell(displayLabelBold)="row">
                                    <b-form-checkbox v-model="row.item.displayLabelBold" disabled></b-form-checkbox>
                                </template>
                                <template v-slot:cell(displayLabelItalic)="row">
                                    <b-form-checkbox v-model="row.item.displayLabelItalic" disabled></b-form-checkbox>
                                </template>
                            </b-grid>
                            <!--<b-button-group>
                                <b-button type="button" @click="saveMapping">Cập nhật</b-button>
                                <b-button type="button" variant="primary" @click="addNewMapping" v-if="searchForm.assetTypeGroupId && searchForm.assetMutationTypeId">Thêm mới</b-button>
                            </b-button-group>-->
                        </b-tab>
                        <b-tab title="Cập nhật sách trường dữ liệu">
                            <b-grid :gridOptions="fieldGridOptions"
                                    :items="allAssetFields"
                                    :filter="filterText"
                                    :showActions="false"
                                    gridName="Danh sách trường dữ liệu"
                                    ref="fieldsTable">
                                <template v-slot:actions="row">
                                    <b-form-input v-model="filterText" placeholder="Nhập từ khóa"></b-form-input>
                                    <br />
                                </template>
                                <template v-slot:cell(isNullable)="row">
                                    <b-form-checkbox v-model="row.item.isNullable" disabled></b-form-checkbox>
                                </template>
                                <template v-slot:cell(displayName)="row">
                                    <b-form-input v-model="row.item.displayName" @change="row.item.isDirty = true" class="no-padding"></b-form-input>
                                </template>
                                <template v-slot:cell(lookupDataType)="row">
                                    <b-form-input v-model="row.item.lookupDataType" @change="row.item.isDirty = true" class="no-padding"></b-form-input>
                                </template>
                                <template v-slot:cell(displayFormat)="row">
                                    <b-form-input v-model="row.item.displayFormat" @change="row.item.isDirty = true" class="no-padding"></b-form-input>
                                </template>
                                <template v-slot:cell(displayGroup)="row">
                                    <b-form-input v-model="row.item.displayGroup" @change="row.item.isDirty = true" class="no-padding"></b-form-input>
                                </template>
                            </b-grid>
                            <b-button type="button" @click="saveFields">Cập nhật</b-button>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </b-col>
        </b-row>

        <b-modal :no-enforce-focus="true" id="new-mapping-modal" ref="newMappingModal" size="lg" :title="'Thêm mapping mới'" ok-only @ok="search">
            <b-row>
                <b-col>
                    <b-form-group label="Tên trường:"
                                  label-for="filterMapping"
                                  :label-cols="4"
                                  :horizontal="true"
                                  label-align="right">
                        <b-form-input type="text" id="filterMapping"
                                      v-model="filterMapping">
                        </b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-grid :gridOptions="fieldMappingGridOptions"
                    :items="availableMappings"
                    gridName="Danh sách mapping"
                    selectable
                    :filter="filterMapping"
                    ref="newMappingTable">
                <template v-slot:actions="row">
                    <b-button type="button" variant="primary" @click="addFields">Thêm</b-button>
                </template>
                <template v-slot:cell(isNullable)="row">
                    <b-form-checkbox v-model="row.item.isNullable" disabled></b-form-checkbox>
                </template>
                <template v-slot:cell(_actions)="row">
                    <b-button size="sm" @click.stop="addField(row.item, row.index, $event.target)" title="thêm mới">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                    </b-button>
                </template>
            </b-grid>
        </b-modal>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { mixins } from '@/shared/mixins'
    import { required } from 'vuelidate/lib/validators'

    export default {
        name: 'FieldMapping',
        mixins: [mixins],
        data() {
            return {
                allAssetFields: [],
                filterText: '',
                fieldGridOptions: {
                    fields: [
                        { key: 'name', label: 'Tên trường dữ liệu', sortable: true },
                        { key: 'displayName', label: 'Tên hiển thị', sortable: true },
                        { key: 'isNullable', label: 'Cho phép NULL', sortable: true },
                        { key: 'dataType', label: 'Kiểu dữ liệu', sortable: true },
                        { key: 'lookupDataType', label: 'Dữ liệu lookup', sortable: true },
                        { key: 'displayFormat', label: 'Định dạng hiển thị', sortable: true },
                        //{ key: 'displayGroup', label: 'Nhóm hiển thị', sortable: true }
                    ]
                },
                searchForm: {
                    assetTypeGroupId: null,
                    assetMutationTypeId: null,
                    filter: null
                },
                mappingFields: [],
                gridOptions: {
                    fields: [
                        { key: 'fieldName', label: 'Trường dữ liệu', sortable: false },
                        { key: 'displayName', label: 'Tên hiển thị', sortable: false },
                        { key: 'displayGroupName', label: 'Nhóm hiển thị', sortable: false },
                        { key: 'displayGroupGridColumn', label: 'Độ rộng nhóm', sortable: false },
                        { key: 'displayNewLine', label: 'Xuống dòng', sortable: false },
                        { key: 'displayGridColumn', label: 'Độ rộng grid', sortable: false },
                        { key: 'displayLabelColumn', label: 'Độ rộng label', sortable: false },
                        { key: 'displayLabelBold', label: 'In đậm label', sortable: false },
                        { key: 'displayLabelItalic', label: 'In nghiêng label', sortable: false },
                        { key: 'fieldIsNullable', label: 'Cho phép NULL', sortable: false },
                        { key: 'fieldDataType', label: 'Kiểu dữ liệu', sortable: false },
                        { key: 'isDisplayed', label: 'Được hiển thị', sortable: false },
                        { key: 'isRequired', label: 'Bắt buộc', sortable: false }
                    ]
                },
                availableMappings: [],
                filterMapping: null,
                fieldMappingGridOptions: {
                    fields: [
                        { key: 'name', label: 'Trường dữ liệu', sortable: true },
                        { key: 'displayName', label: 'Tên hiển thị', sortable: true },
                        //{ key: 'displayGroup', label: 'Nhóm hiển thị', sortable: true },
                        { key: 'isNullable', label: 'Cho phép NULL', sortable: true },
                        { key: 'dataType', label: 'Kiểu dữ liệu', sortable: true }
                    ]
                },
                importFile: null,
                bootstrapGridOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
            }
        },
        computed: {
            ...mapState({
                assetTypeGroups: (state, getters) => getters.assetTypeGroupTree,
                assetMutationTypes: (state, getters) => state.common.assetMutationTypes
            })
        },
        validations: {
            importFile: { required }
        },
        created() {
            this.loadAssetFields();
        },
        methods: {
            loadAssetFields() {
                var vm = this;
                this.$services.get('field-mapping/fields').done((response) => {
                    vm.allAssetFields = response;
                });
            },
            saveFields() {
                var vm = this;
                this.$services.put('field-mapping/fields', this.allAssetFields.filter(x => x.isDirty)).done(() => {
                    vm.$toastr.s('Cập nhật trường dữ liệu thành công');
                });
            },
            search() {
                //this.$refs.mappingTable.refresh();
                var vm = this;

                this.$services.get(`field-mapping/mapping/${this.searchForm.assetTypeGroupId}/${this.searchForm.assetMutationTypeId}`).done((response) => {
                    vm.mappingFields = response;
                });
            },
            saveMapping() {
                var vm = this;
                this.$services.put(`field-mapping/mapping/${this.searchForm.assetTypeGroupId}/${this.searchForm.assetMutationTypeId}`, this.mappingFields).done(() => {
                    vm.$toastr.s('Cập nhật mapping thành công');
                });
            },
            exportExcel() {
                this.$services.download(`field-mapping/mapping/${this.searchForm.assetTypeGroupId}/${this.searchForm.assetMutationTypeId}/export`);
            },
            exportServiceExcel() {
                this.$services.download(`field-mapping/mapping/${this.searchForm.assetTypeGroupId}/${this.searchForm.assetMutationTypeId}/export-service`);
            },
            importExcel() {
                var vm = this;
                this.$v.importFile.$touch();
                if (!this.$v.importFile.$invalid) {
                    if (confirm('Bạn có chắc muôn import file mapping này?')) {
                        var formData = new FormData();
                        formData.append('fileMapping', vm.importFile)
                        this.$services.upload(`field-mapping/mapping/import`, formData).done(() => {
                            vm.$toastr.s('Import mapping thành công');
                        });
                    }
                }
            },
            removeField(item, index) {
                this.mappingFields.splice(index, 1);
                //this.mappingFields.remove(item);
                //var vm = this;
                ////if (confirm('Bạn có chắc chắn muốn xóa mapping này?')) {
                //this.$services.delete(`field-mapping/mapping/${item.assetTypeGroupId}/${item.assetMutationTypeId}/${item.fieldName}`).done(() => {
                //    vm.$toastr.s('Xóa mapping thành công');
                //    vm.search();
                //});
                ////}
            },
            moveUp(item, index) {
                this.mappingFields.swapItems(index, index - 1);
            },
            moveDown(item, index) {
                this.mappingFields.swapItems(index, index + 1);
            },
            removeFields() {
                var vm = this;
                var selectedItems = this.$refs.mappingTable.selectedRows;
                if (selectedItems.length > 0) {
                    //if (confirm('Bạn có chắc chắn muốn xóa mapping này?')) {
                    this.$services.delete(`field-mapping/mapping`, selectedItems).done(() => {
                        vm.$toastr.s('Xóa mapping thành công');
                        vm.search();
                    });
                    //}
                }
            },
            addNewMapping() {
                var vm = this;

                vm.$services.get(`field-mapping/mapping/available?assetTypeGroupId=${vm.searchForm.assetTypeGroupId}&assetMutationTypeId=${vm.searchForm.assetMutationTypeId}`).done((data) => {
                    vm.availableMappings = data;
                    vm.$refs.newMappingModal.show();
                });
            },
            addField(item) {
                var vm = this;
                vm.$services.post(`field-mapping/mapping?assetTypeGroupId=${vm.searchForm.assetTypeGroupId}&assetMutationTypeId=${vm.searchForm.assetMutationTypeId}`, [item.name]).done(() => {
                    vm.availableMappings.remove(item);
                    vm.$refs.newMappingTable.refresh();
                    //vm.search();
                });
            },
            addFields() {
                var vm = this;
                var selectedFields = vm.$refs.newMappingTable.selectedRows;
                if (selectedFields.length > 0) {
                    vm.$services.post(`field-mapping/mapping?assetTypeGroupId=${vm.searchForm.assetTypeGroupId}&assetMutationTypeId=${vm.searchForm.assetMutationTypeId}`, selectedFields.map(x => x.name)).done(() => {
                        for (var i = 0; i < selectedFields.length; i++) {
                            vm.availableMappings.remove(selectedFields[i]);
                        }
                        vm.$refs.newMappingTable.refresh();
                        //vm.search();
                    });
                }
            }
        }
    }
</script>
<style scoped>
    .tableFixHead {
        overflow-y: auto;
    }

        .tableFixHead thead th {
            position: sticky;
            top: 0;
        }

    /* Just common table stuff. Really. */
    table {
        border-collapse: collapse;
        width: 100%;
    }

    th, td {
        padding: 8px 16px;
    }

    th {
        background: #eee;
    }
</style>
